import { IMAGES } from "../constants/images";
import Sidebar from "../components/Sidebar";
import { ICONS } from "../constants/icons";
import { useUser } from "../contexts/UserContext";
import useMoveTo from "../constants/navigation";
import MobileHeader from "../components/MobileHeader";

const PrivacyPolicy = () => {
    const navigate = useMoveTo();
    const { currentUser } = useUser();

    return (
        <div className="h-screen text-white">
            <MobileHeader title="Privacy Policy" isBackBtn={true} />

            <div className="flex">
                <Sidebar />

                <main className="flex-1 h-screen pt-5 pb-20 px-6 overflow-y-auto bg-[#1A1A1A]">
                    {/* Desktop header */}
                    <div className="flex items-center justify-between">
                        <button
                            onClick={() => navigate(-1)}
                            className="flex-shrink-0 md:block hidden"
                        >
                            <img
                                src={ICONS.arrowBack}
                                className="w-4 h-4 md:w-5 md:h-5"
                                alt="Back"
                            />
                        </button>

                        <h2 className="text-2xl md:text-3xl font-semibold text-main hidden md:block">
                            Privacy Policy
                        </h2>
                        <div />
                    </div>

                    {/* Content */}
                    <div className="max-w-3xl mx-auto pt-2 lg:pt-20 space-y-8 text-sm leading-relaxed">
                        <div className="text-center mb-8">
                            <p className="text-lg text-gray-400">
                                <strong>Last Updated: July 26, 2025</strong>
                            </p>
                        </div>

                        <p>
                            This Privacy Policy describes Our policies and procedures on the
                            collection, use and disclosure of Your information when You use the
                            Service and tells You about Your privacy rights and how the law
                            protects You.
                        </p>

                        <p>
                            We use Your Personal Data to provide and improve the Service. By
                            using the Service, You agree to the collection and use of
                            information in accordance with this Privacy Policy.
                        </p>

                        {/* Interpretation & Definitions */}
                        <section>
                            <h3 className="text-lg font-semibold mb-3">
                                Interpretation and Definitions
                            </h3>

                            <h4 className="font-semibold mb-2">Interpretation</h4>
                            <p className="mb-4">
                                The words of which the initial letter is capitalized have
                                meanings defined under the following conditions. The following
                                definitions shall have the same meaning regardless of whether
                                they appear in singular or in plural.
                            </p>

                            <h4 className="font-semibold mb-2">Definitions</h4>
                            <ul className="list-disc list-inside space-y-2 ml-4">
                                <li><strong>Account:</strong> A unique account created for You to access our Service.</li>
                                <li><strong>Affiliate:</strong> An entity under common control with the Company.</li>
                                <li><strong>Application:</strong> Zylen, the software program.</li>
                                <li><strong>Company:</strong> JOSHUA FARRER (PTY) LTD, 12 Jonkershoek, Stellenbosch.</li>
                                <li><strong>Country:</strong> South Africa.</li>
                                <li><strong>Device:</strong> Any device that can access the Service.</li>
                                <li><strong>Personal Data:</strong> Information relating to an identifiable individual.</li>
                                <li><strong>Service:</strong> The Zylen application.</li>
                                <li><strong>You:</strong> The individual using the Service.</li>
                            </ul>
                        </section>

                        {/* Data Collection */}
                        <section>
                            <h3 className="text-lg font-semibold mb-3">
                                Collecting and Using Your Personal Data
                            </h3>

                            <h4 className="font-semibold mb-2">Types of Data Collected</h4>

                            <p className="font-semibold mt-3">Personal Data</p>
                            <ul className="list-disc list-inside space-y-2 ml-4">
                                <li>Email address</li>
                                <li>First and last name</li>
                                <li>Address, State, Province, ZIP/Postal code, City</li>
                                <li>Usage Data</li>
                            </ul>

                            <p className="font-semibold mt-4">Usage Data</p>
                            <p>
                                Usage Data is collected automatically and may include IP
                                address, browser type, pages visited, time and date of visits,
                                and diagnostic data.
                            </p>
                        </section>

                        {/* App Permissions */}
                        <section>
                            <h3 className="text-lg font-semibold mb-3">
                                Information Collected While Using the Application
                            </h3>
                            <p>
                                With Your permission, We may collect pictures and other
                                information from your Device's camera and photo library to
                                provide application features.
                            </p>
                            <p className="mt-2">
                                You can enable or disable access to this information at any time
                                through your device settings.
                            </p>
                        </section>

                        {/* Data Usage */}
                        <section>
                            <h3 className="text-lg font-semibold mb-3">
                                Use of Your Personal Data
                            </h3>
                            <ul className="list-disc list-inside space-y-2 ml-4">
                                <li>To provide and maintain the Service</li>
                                <li>To manage Your account</li>
                                <li>To contact You regarding updates</li>
                                <li>For business transfers</li>
                                <li>To comply with legal obligations</li>
                            </ul>
                        </section>

                        {/* Retention */}
                        <section>
                            <h3 className="text-lg font-semibold mb-3">
                                Retention of Your Personal Data
                            </h3>
                            <p>
                                The Company will retain Your Personal Data only for as long as
                                necessary to comply with legal obligations and business needs.
                            </p>
                        </section>

                        {/* Security */}
                        <section>
                            <h3 className="text-lg font-semibold mb-3">
                                Security of Your Personal Data
                            </h3>
                            <p>
                                While We strive to use commercially acceptable means to protect
                                Your Personal Data, no method of transmission over the Internet
                                is 100% secure.
                            </p>
                        </section>

                        {/* Children */}
                        <section>
                            <h3 className="text-lg font-semibold mb-3">
                                Children’s Privacy
                            </h3>
                            <p>
                                Our Service does not address anyone under the age of 13. We do
                                not knowingly collect Personal Data from children under 13.
                            </p>
                        </section>

                        {/* Contact */}
                        <section>
                            <h3 className="text-lg font-semibold mb-3">Contact Us</h3>
                            <p>
                                If you have any questions about this Privacy Policy, contact us
                                at:
                            </p>
                            <p className="mt-2 font-semibold">
                                Email:{" "}
                                <a
                                    href="mailto:retief@capecodes.com"
                                    className="text-main underline"
                                >
                                    retief@capecodes.com
                                </a>
                            </p>
                        </section>
                    </div>
                </main>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
